var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.error
      ? _c("div", { staticClass: "text-center my-5" }, [
          _c("p", { staticClass: "text-secondary" }, [
            _vm._v(_vm._s(_vm.$t("common.error_fetch_data"))),
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "text-primary link",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.fetchData.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(_vm._s(_vm.$t("common.rfrsh_page")) + " "),
              _c("i", { staticClass: "icon fa fa-refresh" }),
            ]
          ),
        ])
      : _c(
          "div",
          { staticClass: "my-5" },
          [
            _c(
              "b-row",
              { staticClass: "form-group" },
              [
                _c(
                  "b-col",
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("monitoring.cashflow.period_cashflow")) +
                          " :"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select", {
                      staticClass: "custom-select",
                      attrs: { required: "", options: _vm.periodOptions },
                      on: { change: _vm.changeDateCashFlow },
                      model: {
                        value: _vm.sPeriodCashFlow,
                        callback: function ($$v) {
                          _vm.sPeriodCashFlow = $$v
                        },
                        expression: "sPeriodCashFlow",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("monitoring.cashflow.period_forecast")) +
                          " :"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b-form-select", {
                      staticClass: "custom-select",
                      attrs: { required: "", options: _vm.periodOptions },
                      on: { change: _vm.changeDatePrevision },
                      model: {
                        value: _vm.sPeriodPrevision,
                        callback: function ($$v) {
                          _vm.sPeriodPrevision = $$v
                        },
                        expression: "sPeriodPrevision",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "spacer" }),
            _vm._v(" "),
            _vm.chartData
              ? _c("BarChart", {
                  attrs: { chartData: _vm.chartData, options: _vm.options },
                })
              : _c(
                  "div",
                  { staticClass: "text-center" },
                  [_c("b-spinner", { staticClass: "greenFont" })],
                  1
                ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }